// SHOWS
export const FB_META_SHOW_TITLE = 'show_title';

// AUDIO
export const FB_META_PERCENTAGE_PROGRESS = 'percentage_progress';
export const FB_META_TOTAL_LISTENING_TIME = 'total_listening_time';